module.exports = __webpack_public_path__ + "img/img1.296fb988.png";